import script from "./TiposProdutoCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./TiposProdutoCadastro.vue?vue&type=script&setup=true&lang=js"

import "./TiposProdutoCadastro.vue?vue&type=style&index=0&id=0f3d4cf2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f3d4cf2"]])

export default __exports__